import React, { useState } from "react";
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  GithubAuthProvider,
  FacebookAuthProvider,
} from "firebase/auth";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import styles from "../styles/Auth.module.css";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const checkUsernameAndRedirect = async () => {
    const userRef = doc(db, "users", auth.currentUser.uid);
    const userSnap = await getDoc(userRef);
    if (!userSnap.exists() || !userSnap.data().username) {
      navigate("/set-username");
    } else {
      navigate("/feed");
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      await checkUsernameAndRedirect();
    } catch (err) {
      alert(err.message);
    }
  };

  const handleProviderLogin = async (Provider) => {
    try {
      const provider = new Provider();
      await signInWithPopup(auth, provider);
      await checkUsernameAndRedirect();
    } catch (err) {
      if (err.code === "auth/popup-closed-by-user") {
        alert("You closed the login popup. Please try again.");
      } else {
        alert(err.message);
      }
    }
  };

  return (
    <div className={styles.authContainer}>
      <div className={styles.authCard}>
        <h2 className={styles.title}>IntraUni</h2>
        <form onSubmit={handleLogin} className={styles.form}>
          <div className={styles.inputGroup}>
            <input
              className={styles.input}
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className={styles.inputGroup}>
            <input
              className={styles.input}
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className={styles.submitBtn}>
            Log In
          </button>
        </form>

        <div className={styles.divider}>
          <span className={styles.dividerText}>OR</span>
        </div>

        <div className={styles.socialButtons}>
          <button onClick={() => handleProviderLogin(GoogleAuthProvider)} className={styles.socialBtn}>
            Google
          </button>
          <button onClick={() => handleProviderLogin(GithubAuthProvider)} className={styles.socialBtn}>
            GitHub
          </button>
        </div>

        <div className={styles.switchText}>
          Don't have an account?
          <span onClick={() => navigate("/signup")} className={styles.switchLink}>
            Sign up
          </span>
        </div>
      </div>
    </div>
  );
}
